export default "__VITE_ASSET__fG8bIEof__"